// extracted by mini-css-extract-plugin
export default {"folderList":"styles-module__folderList__src-labstep-web-components-Folder-List-_wyOGJ"};